const AUTHORIZATION_BASE = "/authorization";
const UTILITIES_BASE = "/utilities";
const PMS_BASE = "/pms";

export default {
  AUTHORIZATION_BASE,
  UTILITIES_BASE,
  PMS_BASE,
};
